exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._33CvMKqfH4Yf0j{padding:0;margin:0;width:22px;height:22px;margin-top:6px;justify-content:center;align-items:center;margin-left:auto;background-color:transparent;border-radius:4px;box-shadow:none;display:flex;overflow:hidden;text-decoration:none;transition-property:background-color,border-color,box-shadow;transition-duration:85ms;transition-timing-function:ease;cursor:pointer;font-weight:400;text-align:left}._33CvMKqfH4Yf0j:hover{background-color:rgba(9,30,66,.08)}._33CvMKqfH4Yf0j:active{background-color:rgba(9,30,66,.13)}._33CvMKqfH4Yf0j:active,._33CvMKqfH4Yf0j:hover{color:rgba(9,30,66,.77)}._3SBHBJq0AAxzqg,._33CvMKqfH4Yf0j:focus{color:rgba(9,30,66,.66)}._3SBHBJq0AAxzqg{height:auto;width:100%;padding:6px 8px 6px 0;box-shadow:none;font-weight:400}", ""]);

// exports
exports.locals = {
	"createTeamButton": "_33CvMKqfH4Yf0j",
	"fullTab": "_3SBHBJq0AAxzqg"
};